/**
 * @file site-id.interceptor.ts
 * @description {@link https://jira.walmart.com/browse/WDE-9442}
 *  An interceptor to add the 'wm-site-id' header to all outgoing API calls (monolith & watt) from Dashboard.
 *  As per {@link https://jira.walmart.com/browse/WDE-6036}, the value of the header is
 *  a hard-coded value retrieved through SiteIdService.
 */

import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SiteIdService } from '../services/site-id.service';

@Injectable()
export class SiteIdInterceptor implements HttpInterceptor {
    constructor(private readonly _siteIdService: SiteIdService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        request = request.clone({
            setHeaders: { 'wm-site-id': this._siteIdService.siteId }
        });

        return next.handle(request);
    }
}

export const siteIdInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: SiteIdInterceptor,
    multi: true,
};
